import { render, staticRenderFns } from "./ObjectActionBar.vue?vue&type=template&id=1c0e51ec"
import script from "./ObjectActionBar.vue?vue&type=script&lang=ts"
export * from "./ObjectActionBar.vue?vue&type=script&lang=ts"
import style0 from "./ObjectActionBar.vue?vue&type=style&index=0&id=1c0e51ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports